"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _icons = require("@chakra-ui/icons");
var _react = require("@chakra-ui/react");
var _react2 = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PAGINATION_COLORS = {
  primaryColor: '#00798E',
  borderColor: '#CCCCCC',
  disabledColor: '#9CA3AF'
};
var PAGINATION_CONFIG = {
  MAX_PAGES_WITHOUT_ELLIPSIS: 6,
  MIN_PAGES_FOR_DISPLAY: 1,
  PAGES_THRESHOLD_FOR_SIMPLE_DISPLAY: 6,
  EARLY_PAGE_THRESHOLD: 3,
  LATE_PAGE_THRESHOLD: 2,
  PAGES_IN_START_GROUP: 5,
  PAGES_IN_END_GROUP: 5,
  PAGES_AROUND_CURRENT: 1,
  PAGES_FROM_END_FOR_CONTEXT: 4
};
var MOBILE_PAGINATION_CONFIG = {
  MAX_PAGES_WITHOUT_ELLIPSIS: 6,
  PAGES_THRESHOLD_FOR_SIMPLE_DISPLAY: 6,
  EARLY_PAGE_THRESHOLD: 3,
  LATE_PAGE_THRESHOLD: 2,
  MAX_PAGES_LIMIT: 6
};
var Pagination = _ref => {
  var {
    currentPage,
    totalPages,
    onPageChange,
    isDisabled = false
  } = _ref;
  var [isExtraSmall] = (0, _react.useMediaQuery)('(max-width: 375px)');
  if (totalPages <= PAGINATION_CONFIG.MIN_PAGES_FOR_DISPLAY) return null;
  var getVisiblePages = () => {
    var pages = [];
    if (isExtraSmall) {
      if (totalPages <= MOBILE_PAGINATION_CONFIG.PAGES_THRESHOLD_FOR_SIMPLE_DISPLAY) {
        for (var i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        if (currentPage <= MOBILE_PAGINATION_CONFIG.EARLY_PAGE_THRESHOLD) {
          pages.push(1, 2, 3);
          pages.push('...');
          pages.push(totalPages);
        } else if (currentPage > totalPages - MOBILE_PAGINATION_CONFIG.LATE_PAGE_THRESHOLD) {
          pages.push(1);
          pages.push('...');
          pages.push(totalPages - 2, totalPages - 1, totalPages);
        } else {
          pages.push(1);
          pages.push('...');
          pages.push(currentPage - 1, currentPage, currentPage + 1);
          pages.push('...');
          pages.push(totalPages);
        }
      }
    } else if (totalPages <= PAGINATION_CONFIG.PAGES_THRESHOLD_FOR_SIMPLE_DISPLAY) {
      for (var _i = 1; _i <= totalPages; _i++) {
        pages.push(_i);
      }
    } else {
      pages.push(1);
      if (currentPage <= PAGINATION_CONFIG.EARLY_PAGE_THRESHOLD) {
        pages.push(2, 3, 4, PAGINATION_CONFIG.PAGES_IN_START_GROUP);
        if (totalPages > PAGINATION_CONFIG.MAX_PAGES_WITHOUT_ELLIPSIS) {
          pages.push('...');
        }
        pages.push(totalPages);
      } else if (currentPage >= totalPages - PAGINATION_CONFIG.LATE_PAGE_THRESHOLD) {
        if (totalPages > PAGINATION_CONFIG.PAGES_IN_END_GROUP) {
          pages.push('...');
        }
        pages.push(totalPages - PAGINATION_CONFIG.PAGES_FROM_END_FOR_CONTEXT, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push('...');
        pages.push(currentPage - PAGINATION_CONFIG.PAGES_AROUND_CURRENT, currentPage, currentPage + PAGINATION_CONFIG.PAGES_AROUND_CURRENT);
        pages.push('...');
        pages.push(totalPages);
      }
    }
    return pages;
  };
  var visiblePages = getVisiblePages();
  return (0, _jsxRuntime.jsxs)(_react.Flex, _objectSpread(_objectSpread({}, styles.container), {}, {
    "data-testid": "pagination",
    children: [(0, _jsxRuntime.jsx)(_react.Button, _objectSpread(_objectSpread({}, styles.navButton), {}, {
      isDisabled: currentPage === 1 || isDisabled,
      onClick: () => !isDisabled && onPageChange(currentPage - 1),
      "data-testid": "pagination-prev",
      "aria-label": "Go to previous page",
      children: (0, _jsxRuntime.jsx)(_icons.ChevronLeftIcon, {})
    })), visiblePages.map((page, index) => {
      if (page === '...') {
        return (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, styles.ellipsis), {}, {
          "data-testid": "pagination-ellipsis",
          children: "..."
        }), "ellipsis-".concat(index));
      }
      var pageNumber = page;
      var isActive = pageNumber === currentPage;
      return (0, _jsxRuntime.jsx)(_react.Button, _objectSpread(_objectSpread(_objectSpread({}, styles.pageButton), isActive ? styles.activePageButton : {}), {}, {
        isDisabled: isDisabled,
        onClick: () => !isDisabled && onPageChange(pageNumber),
        "data-testid": "pagination-page-".concat(pageNumber),
        "aria-label": "Go to page ".concat(pageNumber),
        "aria-current": isActive ? 'page' : undefined,
        children: pageNumber
      }), pageNumber);
    }), (0, _jsxRuntime.jsx)(_react.Button, _objectSpread(_objectSpread({}, styles.navButton), {}, {
      isDisabled: currentPage === totalPages || isDisabled,
      onClick: () => !isDisabled && onPageChange(currentPage + 1),
      "data-testid": "pagination-next",
      "aria-label": "Go to next page",
      children: (0, _jsxRuntime.jsx)(_icons.ChevronRightIcon, {})
    }))]
  }));
};
exports.Pagination = Pagination;
var styles = {
  container: {
    justify: 'center',
    align: 'center',
    gap: 1,
    py: 4,
    px: 2,
    minW: '320px',
    transition: 'all 0.2s ease-in-out'
  },
  navButton: {
    size: 'sm',
    variant: 'outline',
    borderColor: PAGINATION_COLORS.borderColor,
    color: PAGINATION_COLORS.primaryColor,
    bg: 'white',
    w: '40px',
    h: '40px',
    minW: 'unset',
    fontSize: 'sm',
    p: 0,
    transition: 'all 0.15s ease-in-out',
    _hover: {
      bg: PAGINATION_COLORS.primaryColor,
      color: 'white',
      borderColor: PAGINATION_COLORS.primaryColor
    },
    _disabled: {
      opacity: 0.4,
      cursor: 'not-allowed',
      _hover: {
        bg: 'white',
        color: PAGINATION_COLORS.disabledColor,
        borderColor: PAGINATION_COLORS.borderColor
      }
    }
  },
  pageButton: {
    size: 'sm',
    variant: 'outline',
    borderColor: PAGINATION_COLORS.borderColor,
    color: 'black',
    bg: 'white',
    w: {
      base: '30px',
      sm: '40px'
    },
    h: {
      base: '38px',
      sm: '40px'
    },
    minW: 'unset',
    fontSize: 'sm',
    fontWeight: 'normal',
    p: 0,
    transition: 'all 0.15s ease-in-out',
    _hover: {
      bg: PAGINATION_COLORS.primaryColor,
      color: 'white',
      borderColor: PAGINATION_COLORS.primaryColor
    }
  },
  activePageButton: {
    bg: PAGINATION_COLORS.primaryColor,
    color: 'white',
    borderColor: PAGINATION_COLORS.primaryColor,
    fontWeight: 'bold',
    _hover: {
      bg: PAGINATION_COLORS.primaryColor,
      color: 'white',
      borderColor: PAGINATION_COLORS.primaryColor
    }
  },
  ellipsis: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    w: {
      base: '15px',
      sm: '40px'
    },
    h: {
      base: '38px',
      sm: '40px'
    },
    border: {
      base: 'none',
      sm: '1px solid'
    },
    borderColor: PAGINATION_COLORS.borderColor,
    bg: 'white',
    color: PAGINATION_COLORS.disabledColor,
    fontWeight: 'bold',
    fontSize: 'sm',
    cursor: 'default',
    userSelect: 'none',
    borderRadius: 'md'
  }
};